import { React, useEffect, useState } from "react";
import { Header } from "./../Header";
import { Layout } from "./Layout";
import { Link } from "react-router-dom";
import { Sidebar } from "../Sidebar";
import axios from "axios";
import ToastMessage from "../ToastMessage";
import { base_url } from "../../context/Authcontext";
import "bootstrap/dist/css/bootstrap.min.css";
import { HeaderSmall } from "../HeaderSmall";
import "../../assets/AdminCss/register.css"
import toast from "react-hot-toast";
import { useTheme } from "../../context/ThemeContext";
import MarqueeBottom from "../components/MarqueeBottom";

const handleFooterLink = () => {
  toast.success("Coming Soon!", {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
export const Withdraw = () => {
  const [activeBank, setActiveBank] = useState(0);
  const [addaccount, setaddaccount] = useState(false);
  const [existaccount, setexistaccount] = useState(true);
  const [addpinmodal, setaddpinmodal] = useState(false);
  const [amount, setamount] = useState(300);
  const [isSidebar, setSidebar] = useState(false);
  const [useBankList, setUserBankList] = useState(null);
  const [bankList, setBankList] = useState([]);
  const [withdrawHistory, setWithdrawHistory] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { themeColors } = useTheme();
  const [bankDetails, setBankDetails] = useState({
    Payment_option: "",
    Holder_name: "",
    Bank_name: "",
    Account_number: "",
    ifsc_code: "",
    upiId: "",
  });

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(bankDetails, "posting bankdetails");
    if (
      !bankDetails.Payment_option ||
      !bankDetails.Holder_name ||
      !bankDetails.Bank_name ||
      !bankDetails.Account_number ||
      !bankDetails.ifsc_code ||
      !bankDetails.ifsc_code ||
      !bankDetails.upiId
    ) {
      ToastMessage(0, "All fields are required");
      return;
    }
    try {
      const res = await axios.post(
        `${base_url}/api/webapi/withdraw/add_bank_card`,
        { bankDetails },
        {
          withCredentials: true,
          headers: {  
            Accept: "application/json",
          },
        }
      );
      // console.log('ress',res);
      setRefresh(!refresh);
      if (res.data.status) {
        setexistaccount(!existaccount);
        setaddaccount(!addaccount);
        ToastMessage(1, res.data.message);
      } else {
        ToastMessage(0, res.data.message);
      }
    } catch (err) {
      ToastMessage(0, "error");
    }
  };
  const handleWithdrawChange = (e) => {
    setamount(e.target.value);
  };
  const handleWithdrawSubmit = async (e) => {
    e.preventDefault();
    if (useBankList?.length === 0) {
      ToastMessage(0, "Please Add Bank Account To Withdraw");
      return;
    }

    try {
      const bankac = useBankList && useBankList[activeBank].bankAccountNumber;
      const recipientName =
        useBankList && useBankList[activeBank].recipientName;
      const withdrawAmount = amount;
      const bankname = useBankList && useBankList[activeBank].bankName;
      const ifsc = useBankList && useBankList[activeBank].IFSC;
      if (bankac && recipientName && withdrawAmount && bankname && ifsc) {
        const res = await axios.post(
          `${base_url}/api/webapi/withdraw/create`,
          {
            withdrawalMethod: "BANK_CARD",
            bankac,
            recipientName,
            withdrawAmount,
            bankname,
            ifsc,
          },
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
            },
          }
        );
        console.log("res width", res);
        if (res.data.status === true) {
          ToastMessage(1, res.data.message);
          setRefresh(!refresh);
        } else if (res.data.status === false) {
          ToastMessage(0, res.data.message);
        }
      } else {
        console.log("error");
        ToastMessage(0, "All details are required");
      }
    } catch (err) {
      console.log(err);
      ToastMessage(0, "error");
    }
  };

  useEffect(() => {
    const fetchBankList = async () => {
      try {
        const res = await axios.get("/bank_list.json");
        // console.log("banklist", res.data.data.banklist);
        setBankList(res.data.data.banklist);
      } catch (err) {
        console.log(err);
      }
    };
    const fetchUserBank = async () => {
      try {
        const res = await axios.post(
          `${base_url}/api/webapi/withdraw/bank_card`,
          {},
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
            },
          }
        );

        if (res.data.status) {
          setUserBankList(res.data.data);
        }
        // console.log(useBankList);
      } catch (err) {
        console.log(err);
      }
    };

    const fetchWithdrawlHistory = async () => {
      try {
        const res = await axios.post(
          `${base_url}/api/webapi/withdraw/history`,
          {
            withCredentials: true,
            headers: {
              Accept: "application/json",
            },
          }
        );
        setWithdrawHistory(res.data.withdrawList);
        // console.log("res history", res.data.withdrawList);
      } catch (err) {
        console.log(err);
      }
    };
    fetchUserBank();
    fetchBankList();
    fetchWithdrawlHistory();
  }, [existaccount, refresh]);
  return (
    <>
    <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
     <div className="header-large">
        {/* <Header isSidebar={isSidebar} setSidebar={setSidebar} refreshHeader={refresh} /> */}
        <Header isSidebar={isSidebar} setSidebar={setSidebar} show={showCanvas} handleShow={handleCanvasShow} handleClose={handleCanvasClose} />
      </div>
      <div className="header-small">
        <Header isSidebar={isSidebar} setSidebar={setSidebar} />
        {/* <HeaderSmall /> */}
      </div>
       

      <div _ngcontent-hdd-c80="" style={{backgroundColor: themeColors['--dark-theme-color-navbar']}}>
        <div className="marquee">
          <marquee>
            👉👉🏏WOMEN BIG BASH 2024 PREMIUM MATCH AND FANCY MARKETS ARE
            AVAILABLE. PLAY NOW AND WIN BIG WITH KHELOYAR.🏏.💰GET CASH BONUS ON
            EVERY DEPOSIT 💸..👈👈
          </marquee>
          <app-sitefooter
            _ngcontent-mkq-c100=""
            className="ng-tns-c100-1"
            _nghost-mkq-c94=""
          >
            {/* <div
              _ngcontent-mkq-c94=""
              id="site_footer-settings"
              className="site_footer "
              style={{ display: "block" }}
            >
              <div
                _ngcontent-mkq-c94=""
                style={{ backgroundColor: "grey" }}
                className="site_footer_inn"
              >
                <ul
                  _ngcontent-mkq-c94=""
                  className="nav-bottom-site site-ui-inn"
                >
                 
                  
                 <div style={{width:"99%"}} className="d-flex justify-content-between">
                 <div className="d-flex">
                  <li _ngcontent-mkq-c94="">
                      <Link _ngcontent-mkq-c94="" to="/">
                        <img
                          _ngcontent-mkq-c94=""
                          className="icon-navbar-site"
                          style={{ maxWidth: "18px" }}
                          alt="icon_Kheloyaar360"
                          src="/assets/images/27500.png"
                        />
                      </Link>
                    </li>

                   
                      

                    
                   
                     
                     
                  </div>
                   <div className="d-flex gap-3">
                   <li
                      _ngcontent-mkq-c94=""
                      className="hide-specific ng-star-inserted "
                      tabIndex={0}
                      onClick={handleFooterLink}
                    >
                      <Link _ngcontent-mkq-c94="" className="list-icon-bg">
                        <img
                          src="https://daba.b-cdn.net/bet365exch.in/B.svg"
                          alt=""
                          _ngcontent-mkq-c94=""
                          className="liveCasinoss"
                        />
                      </Link>
                    </li>

                    <li _ngcontent-mkq-c94="">
                      <Link _ngcontent-mkq-c94="" to="/menu">
                        <img
                          _ngcontent-mkq-c94=""
                          className="icon-navbar-site"
                          style={{ maxWidth: "18px" }}
                          alt="icon_Kheloyaar360"
                          src="https://dabba.b-cdn.net/global/menuglobal.svg"
                        />
                      </Link>
                    </li>
                   </div>
                 </div>
                  
                </ul>
              </div>
            </div> */}
          </app-sitefooter>
        </div>
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs">
                {/* <Layout /> */}
                <div
                  _ngcontent-hdd-c162=""
                  className="col-12 mt-2 px-1 centralized_css"
                >
                  <router-outlet _ngcontent-hdd-c162=""></router-outlet>
                  <app-with-draw
                    _nghost-hdd-c174=""
                    className="ng-star-inserted"
                  >
                    <div _ngcontent-hdd-c174="" className="container withdraw">
                      <h3
                        _ngcontent-hdd-c174=""
                        className="text-center mt-2 ng-star-inserted"
                        style={{ fontFamily: "sans-serif", color: themeColors['--dark-theme-white-color'] }}
                      >
                        {" "}
                        Withdraw Request{" "}
                      </h3>

                      <div className="d-flex align-items-center justify-content-center">
                        <ul
                          style={{
                            listStyle: "disc",
                            margin: "10px",
                            fontFamily: "sans-serif",
                            color: themeColors['--dark-theme-white-color']
                          }}
                          _ngcontent-hdd-c174=""
                          className="withdraw-text-list ng-star-inserted "
                        >
                          <li>
                            The bonus amount can be used to place bets across
                            the platform and the winnings can be withdrawn.
                          </li>
                          <li>
                            In case of Any withdrawal issue i.e: Late
                            withdrawal, bank issue etc client can complain on
                            withdraw issue whatsapp given below.
                          </li>
                          <li>
                            If the withdrawals are pending from the bank, it may
                            take upto 72 banking hours for your transaction to
                            clear.
                          </li>
                        </ul>
                      </div>
                      <div
                        _ngcontent-hdd-c174=""
                        className="d-flex justify-content-center align-items-center withdraw-request"
                      >
                        <p _ngcontent-hdd-c174="">
                          {" "}
                          CLICK HERE TO WITHDRAW IN USDT
                          <br _ngcontent-hdd-c174="" /> CLICK HERE FOR ANY
                          WITHDRAW ISSUE{" "}
                        </p>
                      </div>
                      <div
                        _ngcontent-hdd-c174=""
                        className="depositTabsWrapper ng-star-inserted"
                        style={{ paddingTop: "8px" }}
                      >
                        <div
                          _ngcontent-hdd-c174=""
                          className="resetpinbox"
                          onClick={() => setaddpinmodal(true)}
                        >
                          <span _ngcontent-hdd-c174="">
                            CLICK HERE TO RESET WITHDRAW PIN
                          </span>
                        </div>
                      </div>
                      <div
                        _ngcontent-hdd-c174=""
                        className="depositTabsWrapper"
                      >
                        <div _ngcontent-hdd-c174="" className="d-flex box my-2">
                          <Link
                            _ngcontent-hdd-c174=""
                            className="option position-relative"
                            onClick={() => {
                              setaddaccount(true);
                              setexistaccount(false);
                            }}
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className={`${
                                addaccount ? "" : "curvybox curvybox-2"
                              } `}
                            >
                              {" "}
                              Add Account{" "}
                            </div>
                          </Link>
                          <Link
                            _ngcontent-hdd-c174=""
                            className="option position-relative"
                            onClick={() => {
                              setaddaccount(false);
                              setexistaccount(true);
                            }}
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className={`${existaccount ? "" : "curvybox "} `}
                            >
                              {" "}
                              Existing Account{" "}
                            </div>
                          </Link>
                        </div>
                      </div>
                      {addaccount && (
                        <>
                          <form
                            _ngcontent-hdd-c174=""
                            noValidate=""
                            className=" ng-untouched ng-pristine ng-invalid"
                            style={{ padding: "0 1rem 0 1rem" }}
                            onSubmit={handleSubmit}
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className="row"
                              style={{ justifyContent: "space-around" }}
                            >
                              <div
                                _ngcontent-hdd-c174=""
                                className="col-md-12 input-box input-field"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="input-group pl-0"
                                >
                                  <span
                                    _ngcontent-hdd-c174=""
                                    className="d-flex-label"
                                  >
                                    <label
                                      _ngcontent-hdd-c174=""
                                      htmlFor="PaymentOption"
                                      className="text-dark"
                                    >
                                      {" "}
                                      Payment Options{" "}
                                    </label>
                                  </span>
                                  <select
                                    _ngcontent-hdd-c174=""
                                    id="PaymentOption"
                                    formcontrolname="type"
                                    className="filters-xg-dropdown ng-untouched ng-pristine ng-valid"
                                    name="Payment_option"
                                    style={{ height: "45px" }}
                                    onChange={handleChange}
                                  >
                                    <option value="" disabled selected>
                                      Select Bank
                                    </option>
                                    {bankList.map((ele, index) => {
                                      return (
                                        <option key={index}>
                                          {ele.bankName}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="col-md-12 input-box input-field"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="input-group"
                                >
                                  <span
                                    _ngcontent-hdd-c174=""
                                    className="d-flex-label"
                                  >
                                    <label
                                      _ngcontent-hdd-c174=""
                                      htmlFor="holdername"
                                      className="text-dark"
                                    >
                                      {" "}
                                      Holder Name{" "}
                                    </label>
                                  </span>
                                  <input
                                    _ngcontent-hdd-c174=""
                                    id="holdername"
                                    type="text"
                                    formcontrolname="accountHolderName"
                                    appalphabeticonly=""
                                    className="form-control ng-untouched ng-pristine ng-invalid"
                                    placeholder="Holder Name"
                                    name="Holder_name"
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="col-md-12 input-box input-field"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="input-group"
                                >
                                  <span
                                    _ngcontent-hdd-c174=""
                                    className="d-flex-label"
                                  >
                                    <label
                                      _ngcontent-hdd-c174=""
                                      htmlFor="bankname"
                                      className="text-dark"
                                    >
                                      {" "}
                                      Bank Name{" "}
                                    </label>
                                  </span>
                                  <input
                                    _ngcontent-hdd-c174=""
                                    id="bankname"
                                    type="text"
                                    formcontrolname="bankName"
                                    className="form-control ng-untouched ng-pristine ng-invalid"
                                    placeholder="Bank Name"
                                    maxLength="20"
                                    name="Bank_name"
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="col-md-12 input-box input-field"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="input-group"
                                >
                                  <span
                                    _ngcontent-hdd-c174=""
                                    className="d-flex-label"
                                  >
                                    <label
                                      _ngcontent-hdd-c174=""
                                      htmlFor="accountNo"
                                      className="text-dark"
                                    >
                                      {" "}
                                      Account No{" "}
                                    </label>
                                  </span>
                                  <input
                                    _ngcontent-hdd-c174=""
                                    id="accountNo"
                                    type="text"
                                    formcontrolname="accountNumber"
                                    className="form-control ng-untouched ng-pristine ng-invalid"
                                    placeholder="Account No"
                                    name="Account_number"
                                    onChange={handleChange}
                                    maxLength={15}
                                  />
                                </div>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="col-md-12 input-box input-field"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="input-group"
                                >
                                  <span
                                    _ngcontent-hdd-c174=""
                                    className="d-flex-label"
                                  >
                                    <label
                                      _ngcontent-hdd-c174=""
                                      htmlFor="ibnifsccode"
                                      className="text-dark"
                                    >
                                      {" "}
                                      IBAN/IFSC Number{" "}
                                    </label>
                                  </span>
                                  <input
                                    _ngcontent-hdd-c174=""
                                    id="ibnifsccode"
                                    type="text"
                                    formcontrolname="ifscCode"
                                    className="form-control ng-untouched ng-pristine ng-invalid"
                                    placeholder="IBAN/IFSC Number"
                                    name="ifsc_code"
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="col-md-12 input-box input-field"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="input-group"
                                >
                                  <span
                                    _ngcontent-hdd-c174=""
                                    className="d-flex-label"
                                  >
                                    <label
                                      _ngcontent-hdd-c174=""
                                      htmlFor="upiId"
                                      className="text-dark"
                                    >
                                      {" "}
                                      Upi Id
                                    </label>
                                    <label _ngcontent-hdd-c174="">
                                      {" "}
                                      Add Upi Id
                                    </label>
                                  </span>
                                  <input
                                    _ngcontent-hdd-c174=""
                                    id="upiId"
                                    type="text"
                                    formcontrolname="upiId"
                                    className="form-control ng-untouched ng-pristine ng-invalid"
                                    placeholder="Enter your Upi id here"
                                    name="upiId"
                                    onChange={handleChange}
                                  />
                                </div>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="add-account-btn mt-0"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="d-flex w-50"
                                >
                                  <button
                                    _ngcontent-hdd-c174=""
                                    type="submit"
                                    className="btn btn-info w-100"
                                    disabled=""
                                  >
                                    {" "}
                                    Submit{" "}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </>
                      )}
                      {existaccount && (
                        <>
                          <div className="bank-account">
                            {useBankList ? (
                              useBankList.map((ele, index) => {
                                return (
                                  <div
                                    key={index}
                                    _ngcontent-hdd-c174=""
                                    className="col-md-10"
                                    style={{ width: "fit-content" }}
                                  >
                                    <div _ngcontent-hdd-c174="" className="row">
                                      <div
                                        _ngcontent-hdd-c174=""
                                        className="col-md-3 mb-0"
                                        style={{ width: "100%" }}
                                      >
                                        <div
                                          _ngcontent-hdd-c174=""
                                          className="card m-3 zoom"
                                          onClick={() => setActiveBank(index)}
                                        >
                                          <div
                                            _ngcontent-hdd-c174=""
                                            className={`${
                                              activeBank === index
                                                ? "d-block"
                                                : "d-none"
                                            } selected`}
                                          >
                                            <img
                                              _ngcontent-hdd-c174=""
                                              alt=""
                                              src="/assets/images/yellow-tick.svg"
                                            />
                                          </div>
                                          <p
                                            _ngcontent-hdd-c174=""
                                            className="text-white"
                                          >
                                            {ele.recipientName}
                                          </p>
                                          <p
                                            _ngcontent-hdd-c174=""
                                            className="text-white"
                                          >
                                            {ele.bankAccountNumber}
                                          </p>
                                          <p
                                            _ngcontent-hdd-c174=""
                                            className="text-white"
                                          >
                                            {ele.bankName}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="w-100 text-center py-2" style={{color: themeColors['--dark-theme-white-color']}}>
                                Please Add Bank
                              </div>
                            )}
                          </div>
                          <form
                            _ngcontent-hdd-c174=""
                            noValidate=""
                            className="p-4 pt-0 ng-untouched ng-pristine ng-invalid"
                            onSubmit={handleWithdrawSubmit}
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className="row withDrawSection"
                              style={{
                                justifyContent: "space-around",
                                borderRadius: "5px",
                              }}
                            >
                              <div
                                _ngcontent-hdd-c174=""
                                className="col-md-12 input-box input-field mb-0"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="input-group"
                                >
                                  <span
                                    _ngcontent-hdd-c174=""
                                    className="d-flex-label"
                                  >
                                    <label
                                      _ngcontent-hdd-c174=""
                                      htmlFor="ibnifsccode"
                                      className="text-dark"
                                    >
                                      {" "}
                                      Amount
                                    </label>
                                  </span>
                                  <input
                                    id="ibnifsccode"
                                    type="number"
                                    formcontrolname="ifscCode"
                                    name="Amount"
                                    onChange={handleWithdrawChange}
                                    value={amount}
                                    className="form-control ng-untouched ng-pristine ng-invalid"
                                    placeholder="Amount"
                                  />
                                </div>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="withDrawButtons d-flex flex-wrap p-0 mb-0"
                              >
                                <button
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  onClick={() => setamount(300)}
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 300 ? "activeAmount" : ""
                                  }`}
                                >
                                  {" "}
                                  300{" "}
                                </button>
                                <button
                                  onClick={() => setamount(500)}
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 500 ? "activeAmount" : ""
                                  }`}
                                >
                                  {" "}
                                  500
                                </button>
                                <button
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  onClick={() => setamount(5000)}
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 5000 ? "activeAmount" : ""
                                  }`}
                                >
                                  {" "}
                                  5000{" "}
                                </button>
                                <button
                                  onClick={() => setamount(100000)}
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 100000 ? "activeAmount" : ""
                                  }`}
                                >
                                  100000{" "}
                                </button>
                                <button
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  onClick={() => setamount(200000)}
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 200000 ? "activeAmount" : ""
                                  }`}
                                >
                                  {" "}
                                  200000{" "}
                                </button>
                                <button
                                  onClick={() => setamount(500000)}
                                  _ngcontent-hdd-c174=""
                                  type="button"
                                  className={`btn accounts-btn ml-0 mb-0 margin-10 ${
                                    amount === 500000 ? "activeAmount" : ""
                                  }`}
                                >
                                  500000{" "}
                                </button>
                              </div>
                              <div
                                _ngcontent-hdd-c174=""
                                className="add-account-btn mt-2"
                              >
                                <div
                                  _ngcontent-hdd-c174=""
                                  className="d-flex w-50"
                                >
                                  <button
                                    _ngcontent-hdd-c174=""
                                    type="submit"
                                    className="btn btn-info w-100"
                                    disabled=""
                                  >
                                    {" "}
                                    Submit{" "}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                          <div
                            _ngcontent-hdd-c174=""
                            className=" ng-star-inserted"
                          >
                            <div
                              _ngcontent-hdd-c174=""
                              className="table-box mt-0"
                              style={{ overflowX: "auto" }}
                            >
                              <table
                                _ngcontent-hdd-c174=""
                                className="table-bordered"
                                style={{ width: "100%" }}
                              >
                                <thead _ngcontent-hdd-c174="">
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Order No.
                                  </th>
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Account Number
                                  </th>
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Amount
                                  </th>
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Status
                                  </th>
                                  <th
                                    _ngcontent-hdd-c174=""
                                    className="text-center"
                                  >
                                    Date&Time
                                  </th>
                                </thead>
                                <tbody _ngcontent-hdd-c174="">
                                  {withdrawHistory !== null ? (
                                    withdrawHistory?.map((ele, index) => {
                                      console.log(ele);
                                      return (
                                        <tr key={index}>
                                          <td className="text-center">
                                            {ele.orderId}
                                          </td>
                                          <td className="text-center">
                                            {ele.bankAccountNumber}
                                          </td>
                                          <td className="text-center">
                                            {ele.amount}
                                          </td>
                                          <td className="text-center">
                                            {ele.status === 0
                                              ? "Pending"
                                              : ele.status === 1
                                              ? "Success"
                                              : "Cancelled"}
                                          </td>
                                          <td className="text-center">
                                            {ele.today}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <div>loading..</div>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                      <MarqueeBottom onMenuClick={handleCanvasShow} />
                  </app-with-draw>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
      {/* Withdra password section */}
      {addpinmodal && (
        <>
          <section
            aria-hidden="true"
            style={{ zIndex: "1050" }}
            className="modal-backdrop d-block fade show "
          ></section>
          <section role="dialog" className="changepin d-block modal fade show">
            <div role="document" className="modal-dialog">
              <div className="modal-content">
                <app-createpin _nghost-eov-c172="">
                  <div
                    _ngcontent-hdd-c174=""
                    id="createpin-modal"
                    className="modal modal-content"
                  >
                    <div _ngcontent-hdd-c174="" className="header-top">
                      <Link _ngcontent-hdd-c174="">
                        <img
                          _ngcontent-hdd-c174=""
                          onClick={() => setaddpinmodal(false)}
                          src="/assets/images/cross.svg"
                          alt=""
                        />
                      </Link>
                      <span _ngcontent-hdd-c174="">Create Withdraw PIN</span>
                    </div>
                    <div _ngcontent-hdd-c174="" className="pin-modal-body">
                      <form
                        _ngcontent-hdd-c174=""
                        noValidate=""
                        className="p-4 ng-pristine ng-invalid ng-touched"
                      >
                        <div
                          _ngcontent-hdd-c174=""
                          className="row"
                          style={{ justifyContent: "space-around" }}
                        >
                          <div
                            _ngcontent-hdd-c174=""
                            className="col-md-12 input-box"
                          >
                            <label _ngcontent-hdd-c174="" htmlFor="pin">
                              {" "}
                              Pin
                            </label>
                            <sup
                              _ngcontent-hdd-c174=""
                              style={{ color: "#FF1D1D" }}
                            >
                              *
                            </sup>
                            <div
                              _ngcontent-hdd-c174=""
                              className="input-group pl-0"
                            >
                              <Link _ngcontent-hdd-c174="">
                                <svg
                                  _ngcontent-hdd-c174=""
                                  aria-hidden="true"
                                  className="svg-inline--fa fa-eye fa-w-18"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 576 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                                  ></path>
                                </svg>
                              </Link>
                              <input
                                _ngcontent-hdd-c174=""
                                id="pin"
                                formcontrolname="pin"
                                className="form-control ng-pristine ng-invalid ng-touched"
                                placeholder="Enter PIN"
                                type="password"
                                maxLength="4"
                              />
                            </div>
                          </div>
                          <div
                            _ngcontent-hdd-c174=""
                            className="col-md-12 input-box"
                          >
                            <label _ngcontent-hdd-c174="" htmlFor="confirmPin">
                              {" "}
                              Confirm PIN{" "}
                            </label>
                            <sup
                              _ngcontent-hdd-c174=""
                              style={{ color: "#FF1D1D" }}
                            >
                              *
                            </sup>
                            <div _ngcontent-hdd-c174="" className="input-group">
                              <Link _ngcontent-hdd-c174="">
                                <svg
                                  _ngcontent-hdd-c174=""
                                  aria-hidden="true"
                                  className="svg-inline--fa fa-eye fa-w-18"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 576 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                                  ></path>
                                </svg>
                              </Link>
                              <input
                                _ngcontent-hdd-c174=""
                                id="confirmPin"
                                formcontrolname="confirmPin"
                                className="form-control ng-untouched ng-pristine ng-invalid"
                                placeholder="Enter Confirm PIN"
                                type="password"
                                maxLength="4"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          _ngcontent-hdd-c174=""
                          className="pin-modal-footer"
                        >
                          <button
                            _ngcontent-hdd-c174=""
                            onClick={() => setaddpinmodal(false)}
                            className="close mdclosebtn"
                          >
                            Close
                          </button>
                          <button
                            _ngcontent-hdd-c174=""
                            type="submit"
                            className="save"
                          >
                            Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </app-createpin>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};
